import type { GrapeAppAuthorization } from "@grape-law-firm/grape-common-notion-client";
import type { GEmployee } from "~/types/person";

export const useUserStore = defineStore("user", () => {
  const info = ref<GEmployee>();
  const authorizations = ref<GrapeAppAuthorization[]>([]);

  return { info, authorizations };
});
